import {useStore} from "vuex";

const useCan = (permission) => {
    const store = useStore();
    let permissions = store?.getters['authentication/userPermissions'];

    return !!permissions?.includes(permission);
};

export default useCan;
